import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlidadeConfigModel } from '../../../core/services/models/alidade-config.model';
import { ApiResponseModel } from '../../../shared/models/api-response.model';
import { BuilderScaleTypeModel } from '../models/builder-scale-type.model';
import { QuestionTypeEnum } from '../models/enums/question.type';
import { SurveyVersionItemTypeModel } from '../models/api/survey-version-tree.model';
import { TargetTypesEnum } from '../models/enums/target-types.type';
import { DistributionTypeModel } from '../../distributions/model/distributions.model';

@Injectable({
  providedIn: 'root',
})
export class MeasureUtilService {
  private readonly apiUrl: string;

  constructor(
    @Inject('ALIDADE_CONFIG') config: AlidadeConfigModel,
    private http: HttpClient,
  ) {
    this.apiUrl = `${config.apiURL}/builder`;
  }

  getQuestionTypes(): Observable<ApiResponseModel<SurveyVersionItemTypeModel<QuestionTypeEnum>[]>> {
    return this.http.get<ApiResponseModel<SurveyVersionItemTypeModel<QuestionTypeEnum>[]>>(
      `${this.apiUrl}/questionTypes`,
    );
  }

  getTargetTypes(): Observable<ApiResponseModel<SurveyVersionItemTypeModel<TargetTypesEnum>[]>> {
    return this.http.get<ApiResponseModel<SurveyVersionItemTypeModel<TargetTypesEnum>[]>>(`${this.apiUrl}/targetTypes`);
  }

  getScaleTypes(): Observable<ApiResponseModel<BuilderScaleTypeModel[]>> {
    return this.http.get<ApiResponseModel<BuilderScaleTypeModel[]>>(`${this.apiUrl}/scaleTypes`);
  }

  getDistributionTypes(): Observable<ApiResponseModel<DistributionTypeModel[]>> {
    return this.http.get<ApiResponseModel<DistributionTypeModel[]>>(`${this.apiUrl}/distributionTypes`);
  }
}
